import { render, staticRenderFns } from "./RemoteDayComponent.vue?vue&type=template&id=3b16fcd1&"
import script from "./RemoteDayComponent.vue?vue&type=script&lang=js&"
export * from "./RemoteDayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports